import { render } from "./CardNoSharedResource.vue?vue&type=template&id=0d74337e&ts=true"
import script from "./CardNoSharedResource.vue?vue&type=script&lang=ts"
export * from "./CardNoSharedResource.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__